/* global axios */
import ApiClient from '../ApiClient';

class AiBotDocumentsAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/documents`, { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(params, { onUploadProgress } = {}) {
    return axios.post(this.url, params, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reindex(id) {
    return axios.post(`${this.url}/${id}/reindex`);
  }

  search(q) {
    return axios.get(`${this.url}/search`, { params: { q } });
  }
}

export default AiBotDocumentsAPI;
